//@ts-check
import alertsHolderStore from "Stores/alertsHolderStore";
import React, { Component } from 'react';

/** @type {((arg0: import("Components/Common/modalWindow").ModalWindowProps) => void) | null} */
let _showModal = null;
/** @type {(() => void) | null} */
let _closeModal = null;

export const SynchronizingTask = {
    waitInSyncQueue: 13,
    loadDocumentsList: 12,
    loadDictionaries: 1,
    loadDocuments: 2,
    removeConsiderationDocuments: 18,
    removingUser: 3,
    removingUserDl: 16,
    removingUserPhysically: 17,
    loadVisaDocuments: 4,
    removeVisaDocuments: 5,
    loadSignDocuments: 6,
    removeSignDocuments: 7,
    loadControlDocuments: 8,
    removeControlDocuments: 9,
    loadUserFolders: 10,
    removeUserFolders: 11,
    loadProjectDocuments: 14,
    removeProjectDocuments: 15,
    loadMeetings: 19,
    removeMeetings: 20,
}

export const SynchronizingStatus = {
    none: 0,
    inProgress: 1,
    completed: 2,
    wasError: 3,
    dmsisDoesNotWorking: 4,
    cancelled: 5
}

/**
 * 
 * @param {UserState} userState 
 * @param {boolean} [isFirstCharToUpper]
 * @returns 
 */
export function GetTaskDescriptionByUserState(userState, isFirstCharToUpper) {
    var taskName = null;
    switch (userState.task) {
        case SynchronizingTask.waitInSyncQueue: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "ожидание")} синхронизации в очереди повторной синхронизации активных пользователей</span>; break;
        case SynchronizingTask.loadDocumentsList: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "подсчёт")} {userState.isMeeting ? "совещаний" : "документов"} для дальнейшей синхронизации</span>; break;
        case SynchronizingTask.loadDictionaries: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "загрузка")} справочников пользователя</span>; break;
        case SynchronizingTask.loadDocuments: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "загрузка")} документов для папки "На рассмотрение"</span>; break;
        case SynchronizingTask.removeConsiderationDocuments: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "удаление")} документов для папки "На рассмотрение"</span>; break;
        case SynchronizingTask.removingUser: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "логическое")} удаление пользователя</span>; break;
        case SynchronizingTask.removingUserDl: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "удаление")} должностного лица <b>{userState.currentProccessedUserDlTitle}</b></span>; break;
        case SynchronizingTask.loadVisaDocuments: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "загрузка")} проектов документов для папки "На визирование"</span>; break;
        case SynchronizingTask.removeVisaDocuments: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "удаление")} проектов документов для папки "На визирование"</span>; break;
        case SynchronizingTask.loadSignDocuments: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "загрузка")} проектов документов для папки "На подпись"</span>; break;
        case SynchronizingTask.removeSignDocuments: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "удаление")} проектов документов для папки "На подпись"</span>; break;
        case SynchronizingTask.loadControlDocuments: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "загрузка")} документов для папки "На контроле"</span>; break;
        case SynchronizingTask.removeControlDocuments: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "удаление")} документов для папки "На контроле"</span>; break;
        case SynchronizingTask.loadUserFolders: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "загрузка")} документов для личных папок</span>; break;
        case SynchronizingTask.removeUserFolders: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "удаление")} документов для личных папок</span>; break;
        case SynchronizingTask.loadProjectDocuments: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "загрузка")} документов для папки "Проекты документов"</span>; break;
        case SynchronizingTask.removeProjectDocuments: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "удаление")} документов для папки "Проекты документов"</span>; break;
        case SynchronizingTask.loadMeetings: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "загрузка")} событий пользователя</span>; break;
        case SynchronizingTask.removeMeetings: taskName = <span>{SetFirstCharToUpper(isFirstCharToUpper, "удаление")} событий пользователя</span>; break;
    }

    return taskName;
}

function SetFirstCharToUpper(isFirstCharToUpper, text) {
    if (isFirstCharToUpper == true) {
        text = text.charAt(0).toUpperCase() + text.slice(1);
    }
    return text;
}

/**
 * @param {string | null} dateStr 
 * @returns {Date | null}
 */
export function GetDateFromString(dateStr) {
    if (!dateStr)
        return null;

    let parsed = Date.parse(dateStr);
    if (!isNaN(parsed))
        return new Date(parsed);

    let dateParts = dateStr.split('.');
    return new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]));
}

/**
 * @param {((arg0: import("Components/Common/modalWindow").ModalWindowProps) => void)} showModal
 * @param {(() => void)} closeModal
 */
export function InitModal(showModal, closeModal) {
    _closeModal = closeModal;
    _showModal = showModal;
}

/**
 * @param {import("Components/Common/modalWindow").ModalWindowProps} settings 
 */
export function ShowModal(settings) {
    if (_showModal != null)
        _showModal(settings);
}

export function CloseModal() {
    if (_closeModal != null)
        _closeModal();
}

let alertIdSeq = 1;

/**
 * @param {("success"|"warning"|"error")} type 
 * @param {React.JSX.Element | string} text 
 * @returns {number}
 */
export function ShowAlert(type, text) {
    return ShowAlert2({
        type: type,
        text: text
    });
}

/**
 * @param {{
 *  type: ("success"|"warning"|"error"),
 *  text: React.JSX.Element | string,
 *  autoClose?: boolean,
 *  buttons?: {title: string, callback?: (() => void) | null}[],
 *  hideClosebutton?: boolean
 *  onInit?: () => void,
 *  onRelease?: () => void
 * }} data 
 * @returns {number}
 */
export function ShowAlert2(data) {
    let autoClose = data.autoClose === false
        ? false : true;
    let hideClosebutton = data.hideClosebutton || false;

    let alertId = alertIdSeq++;
    alertsHolderStore.ShowAlert({
        key: alertId,
        type: data.type,
        text: data.text,
        autoClose: autoClose,
        createdAt: new Date(),
        buttons: data.buttons
            ?.map(x => ({
                key: alertIdSeq++,
                title: x.title || '',
                callback: () => {
                    if (x.callback)
                        x.callback();

                    alertsHolderStore.CloseAlert(alertId, false);
                }
            })) || [],
        hideCloseButton: hideClosebutton,
        closeAlertHandler: () => alertsHolderStore.CloseAlert(alertId, false),
        onInit: () => data.onInit && data.onInit(),
        onRelease: () => data.onRelease && data.onRelease()
    });
    return alertId;
}

/**
 * @param {number} key 
 */
export function CloseAlert(key) {
    alertsHolderStore.CloseAlert(key, false);
}